// Behaviour for the product templates, loaded via theme.liquid.

function initReviewLabels() {
  const process = () => {
    document.querySelectorAll('reviewsio-product-ratings .ruk-rating-snippet-count').forEach((el) => {
      if (el.dataset.reviewLabel === 'done') return
      const count = parseInt(el.textContent.replace(/\D/g, ''), 10)
      if (!count) return
      el.textContent = `${count} ${count === 1 ? 'Bewertung' : 'Bewertungen'}`
      el.dataset.reviewLabel = 'done'

      const snippet = el.closest('.ruk_rating_snippet')
      const rating = snippet && (snippet.getAttribute('title') || '').match(/(\d+)(?:\.(\d))?/)
      if (rating) {
        const span = document.createElement('span')
        span.className = 'ruk-rating-snippet-rating'
        span.textContent = `${rating[1]}.${rating[2] || '0'}`
        snippet.insertBefore(span, el)
      }
    })
  }
  process()
  new MutationObserver(process).observe(document.body, { childList: true, subtree: true })
}

// "#reviews" (rating link in the configurator quick view): scroll to the reviews under the sticky header
function initReviewsAnchor() {
  const widget = document.querySelector('reviewsio-product-reviews-widget')
  if (location.hash !== '#reviews' || !widget) return

  const header = document.querySelector('.site-header')
  const scroll = () => {
    window.scrollTo({ top: widget.getBoundingClientRect().top + window.scrollY - (header ? header.offsetHeight : 0) })
  }
  scroll()
  window.addEventListener('load', scroll, { once: true }) // images above shift the widget
}

function initQuantityMax() {
  const idInput = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]')
  const qtyInput = document.querySelector('.ts-lg-quantity-atc-wrap .js-qty__num')
  const invScript = document.querySelector('product-inventory [data-inventories-json]')
  if (!idInput || !qtyInput || !invScript) return

  let inventories = {}
  try {
    inventories = JSON.parse(invScript.textContent)
  } catch (e) {
    return
  }

  const clamp = () => {
    const inv = inventories[idInput.value]
    const max = inv && inv.policy === 'deny' && inv.quantity > 0 ? inv.quantity : null
    if (max && parseInt(qtyInput.value, 10) > max) qtyInput.value = max
  }

  qtyInput.addEventListener('input', clamp)
  qtyInput.addEventListener('change', clamp)
  const wrapper = qtyInput.closest('.js-qty__wrapper')
  if (wrapper) {
    wrapper.addEventListener('click', (event) => {
      if (event.target.closest('.js-qty__adjust')) requestAnimationFrame(clamp)
    })
  }
  idInput.addEventListener('change', clamp)
  clamp()
}

function initStickyAtc() {
  const bar = document.querySelector('[data-sticky-atc]')
  const wrap = document.querySelector('.ts-lg-quantity-atc-wrap')
  if (!bar || !wrap) return

  const mainAdd = wrap.querySelector('.add-to-cart')
  const mainBis = wrap.querySelector('.klaviyo-bis-trigger')
  const mainQty = wrap.querySelector('.js-qty__num')
  const mainMinus = wrap.querySelector('.js-qty__adjust--minus')
  const mainPlus = wrap.querySelector('.js-qty__adjust--plus')
  const stickyQty = bar.querySelector('[data-sticky-qty]')

  bar.querySelector('[data-sticky-minus]').addEventListener('click', () => mainMinus && mainMinus.click())
  bar.querySelector('[data-sticky-plus]').addEventListener('click', () => mainPlus && mainPlus.click())
  bar.querySelector('[data-sticky-add]').addEventListener('click', () => mainAdd && mainAdd.click())
  bar.querySelector('[data-sticky-bis]').addEventListener('click', (event) => {
    event.preventDefault()
    if (mainBis) mainBis.click()
  })

  const syncQty = () => {
    if (stickyQty && mainQty) stickyQty.textContent = mainQty.value
  }
  if (mainQty) {
    mainQty.addEventListener('input', syncQty)
    mainQty.addEventListener('change', syncQty)
  }
  bar.querySelector('[data-sticky-qty-wrap]').addEventListener('click', () => requestAnimationFrame(syncQty))
  syncQty()

  if (mainAdd) {
    const syncSoldOut = () => bar.classList.toggle('ts-lg-sticky-atc--soldout', mainAdd.disabled)
    new MutationObserver(syncSoldOut).observe(mainAdd, { attributes: true, attributeFilter: ['disabled'] })
    syncSoldOut()
  }

  new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      bar.hidden = entry.isIntersecting
      if (!entry.isIntersecting) syncQty()
      document.body.classList.toggle('has_fixed_cta', !entry.isIntersecting)
    })
  }).observe(wrap)
}

function boot() {
  initReviewLabels()
  initReviewsAnchor()
  initQuantityMax()
  initStickyAtc()
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', boot)
} else {
  boot()
}
